var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256.776,
    height: 170.967
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "account-error_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Rectangle_230",
    "data-name": "Rectangle 230",
    fill: "none",
    d: "M0 0h12.385v7.45H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "account-error_svg__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Rectangle_577",
    "data-name": "Rectangle 577",
    fill: "none",
    stroke: "#10181c",
    strokeWidth: 1,
    d: "M0 0h10.501v10.5H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "account-error_svg__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Rectangle_577-2",
    "data-name": "Rectangle 577",
    fill: "none",
    stroke: "#ff2741",
    strokeWidth: 3,
    d: "M0 0h74v73.993H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "account-error_svg__Holder_-_Danger_Error",
    "data-name": "Holder - Danger Error",
    transform: "translate(-53.417 -315.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account-error_svg__Group_656",
    "data-name": "Group 656",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account-error_svg__Group_654",
    "data-name": "Group 654",
    transform: "translate(14 -10)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "account-error_svg__Rectangle_282",
    "data-name": "Rectangle 282",
    width: 180,
    height: 90,
    rx: 10,
    transform: "translate(105 345)",
    fill: "#2b3236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Line_12",
    "data-name": "Line 12",
    fill: "none",
    stroke: "#4f5558",
    strokeWidth: 1,
    d: "M105 405h180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Line_188",
    "data-name": "Line 188",
    fill: "none",
    stroke: "#737c81",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M148 367h49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Line_189",
    "data-name": "Line 189",
    fill: "none",
    stroke: "#4f5558",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M148 382h113"
  }), /*#__PURE__*/React.createElement("g", {
    id: "account-error_svg__Semicircle",
    transform: "translate(105 361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Rectangle_51",
    "data-name": "Rectangle 51",
    d: "M.784 0h11.108A14.108 14.108 0 0126 14.108 14.892 14.892 0 0111.108 29H.784A.784.784 0 010 28.216V.784A.784.784 0 01.784 0z",
    fill: "#10181c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Rectangle_7",
    "data-name": "Rectangle 7",
    d: "M12 0h48.429A2.571 2.571 0 0163 2.571v18.858A2.571 2.571 0 0160.429 24H12A12 12 0 010 12 12 12 0 0112 0z",
    transform: "translate(225 394)",
    fill: "#ff2741"
  }), /*#__PURE__*/React.createElement("g", {
    id: "account-error_svg__Group_433",
    "data-name": "Group 433",
    transform: "translate(232.508 402.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account-error_svg__Group_432",
    "data-name": "Group 432",
    clipPath: "url(#account-error_svg__clip-path)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.292
  }, /*#__PURE__*/React.createElement("rect", {
    id: "account-error_svg__Rectangle_229",
    "data-name": "Rectangle 229",
    width: 7.029,
    height: 6.092,
    rx: 1.406,
    transform: "translate(.647 .679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_407",
    "data-name": "Path 407",
    d: "M11.544.679L7.676 2.47v2.306l3.87 1.992c.106.082.193.018.193-.141v-5.8c0-.16-.087-.227-.195-.148z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Line_190",
    "data-name": "Line 190",
    fill: "none",
    stroke: "#10181c",
    strokeLinecap: "round",
    strokeWidth: 6,
    opacity: 0.5,
    d: "M254 406h23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "account-error_svg__Icon_-_User",
    "data-name": "Icon - User",
    transform: "translate(107 367.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_4302",
    "data-name": "Path 4302",
    d: "M6.833 10.167s-1-.333-1-2c-.551 0-.551-1.333 0-1.333 0-.223-1-2.667.667-2.333.333-1.333 4-1.333 4.333 0a5.281 5.281 0 01-.333 2.332c.551 0 .551 1.333 0 1.333 0 1.667-1 2-1 2v1.667a23.35 23.35 0 014.124 1.717 7.666 7.666 0 10-10.907.008 23.7 23.7 0 014.117-1.725z",
    transform: "translate(-.167 -.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_4303",
    "data-name": "Path 4303",
    d: "M3.825 20.083a7.663 7.663 0 0010.907-.008",
    transform: "translate(-1.275 -6.692)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "account-error_svg__Group_653",
    "data-name": "Group 653",
    transform: "translate(-16 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "account-error_svg__Rectangle_282-2",
    "data-name": "Rectangle 282",
    width: 180,
    height: 90,
    rx: 10,
    transform: "translate(105 345)",
    fill: "#2b3236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Line_12-2",
    "data-name": "Line 12",
    fill: "none",
    stroke: "#4f5558",
    strokeWidth: 1,
    d: "M105 405h180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Line_188-2",
    "data-name": "Line 188",
    fill: "none",
    stroke: "#737c81",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M148 367h49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Line_189-2",
    "data-name": "Line 189",
    fill: "none",
    stroke: "#4f5558",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M148 382h113"
  }), /*#__PURE__*/React.createElement("g", {
    id: "account-error_svg__Semicircle-2",
    "data-name": "Semicircle",
    transform: "translate(105 361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Rectangle_51-2",
    "data-name": "Rectangle 51",
    d: "M.784 0h11.108A14.108 14.108 0 0126 14.108 14.892 14.892 0 0111.108 29H.784A.784.784 0 010 28.216V.784A.784.784 0 01.784 0z",
    fill: "#10181c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Rectangle_7-2",
    "data-name": "Rectangle 7",
    d: "M12 0h45.429A2.571 2.571 0 0160 2.571v18.858A2.571 2.571 0 0157.429 24H12A12 12 0 010 12 12 12 0 0112 0z",
    transform: "translate(228 394)",
    fill: "#ff2741"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Line_190-2",
    "data-name": "Line 190",
    fill: "none",
    stroke: "#10181c",
    strokeLinecap: "round",
    strokeWidth: 6,
    opacity: 0.5,
    d: "M254 406h23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "account-error_svg__Icon_-_User-2",
    "data-name": "Icon - User",
    transform: "translate(108 367.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_4302-2",
    "data-name": "Path 4302",
    d: "M6.833 10.167s-1-.333-1-2c-.551 0-.551-1.333 0-1.333 0-.223-1-2.667.667-2.333.333-1.333 4-1.333 4.333 0a5.281 5.281 0 01-.333 2.332c.551 0 .551 1.333 0 1.333 0 1.667-1 2-1 2v1.667a23.35 23.35 0 014.124 1.717 7.666 7.666 0 10-10.907.008 23.7 23.7 0 014.117-1.725z",
    transform: "translate(-.167 -.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_4303-2",
    "data-name": "Path 4303",
    d: "M3.825 20.083a7.663 7.663 0 0010.907-.008",
    transform: "translate(-1.275 -6.692)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "account-error_svg__Icon_-_Warning",
    "data-name": "Icon - Warning",
    transform: "translate(235.115 399.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account-error_svg__Group_1511",
    "data-name": "Group 1511",
    clipPath: "url(#account-error_svg__clip-path-2)",
    fill: "none",
    stroke: "#10181c",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_4298",
    "data-name": "Path 4298",
    d: "M5.25 8.063a.281.281 0 110-.562"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_4299",
    "data-name": "Path 4299",
    d: "M5.25 8.063a.281.281 0 100-.562"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Line_552",
    "data-name": "Line 552",
    transform: "translate(5.25 3.563)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 2.25V0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_4300",
    "data-name": "Path 4300",
    d: "M9.61 7.824a1.315 1.315 0 01.139.655A1.329 1.329 0 018.42 9.75H2.081a1.328 1.328 0 01-1.132-.631 1.326 1.326 0 01-.058-1.3L4.06 1.486a1.331 1.331 0 012.381 0z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "account-error_svg__Icon_-_Warning_Large",
    "data-name": "Icon - Warning Large",
    transform: "translate(53.417 420.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account-error_svg__Group_1511-2",
    "data-name": "Group 1511",
    clipPath: "url(#account-error_svg__clip-path-3)",
    fill: "none",
    stroke: "#ff2741",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_4298-2",
    "data-name": "Path 4298",
    d: "M5.83 9.223a.861.861 0 010-1.722",
    transform: "translate(31.167 46.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_4299-2",
    "data-name": "Path 4299",
    d: "M5.25 9.223a.861.861 0 000-1.722",
    transform: "translate(31.746 46.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Line_552-2",
    "data-name": "Line 552",
    transform: "translate(37 25.106)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 15.856V0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_4300-2",
    "data-name": "Path 4300",
    d: "M63.188 50.6a9.269 9.269 0 01.98 4.616 9.366 9.366 0 01-9.368 8.957H10.131a9.361 9.361 0 01-7.977-4.447 9.346 9.346 0 01-.409-9.126L24.077 5.937a9.381 9.381 0 0116.779 0z",
    transform: "translate(4.533 4.535)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "account-error_svg__Group_657",
    "data-name": "Group 657",
    transform: "translate(281.5 315.446)",
    fill: "#737c81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_3941",
    "data-name": "Path 3941",
    d: "M26.577 30.952l4.273-.252a.344.344 0 00.142-.647l-3.775-2.019a2.146 2.146 0 01-1.13-1.767L25.839 22a.344.344 0 00-.647-.142l-2.019 3.772a2.145 2.145 0 01-1.767 1.13l-4.273.249a.344.344 0 00-.142.647l3.775 2.019a2.145 2.145 0 011.13 1.767l.249 4.273a.344.344 0 00.647.142l2.019-3.774a2.146 2.146 0 011.767-1.13",
    transform: "translate(-9.85 -12.701)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_3942",
    "data-name": "Path 3942",
    d: "M6.226 4.639l2.2-1.345a.207.207 0 00-.108-.383H5.743a1.292 1.292 0 01-1.1-.616L3.293.1a.207.207 0 00-.383.108v2.575a1.291 1.291 0 01-.616 1.1L.1 5.229a.207.207 0 00.108.383h2.574a1.289 1.289 0 011.1.616l1.345 2.2a.207.207 0 00.383-.108V5.745a1.292 1.292 0 01.616-1.1",
    transform: "translate(-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_3943",
    "data-name": "Path 3943",
    d: "M59.881 19.513l1.6 1.072a.155.155 0 00.227-.194L60.9 18.64a.968.968 0 01.074-.942l1.072-1.6a.155.155 0 00-.194-.227l-1.751.807a.965.965 0 01-.942-.074l-1.6-1.072a.155.155 0 00-.227.194l.808 1.751a.967.967 0 01-.075.942l-1.072 1.6a.155.155 0 00.194.227l1.751-.807a.965.965 0 01.942.074",
    transform: "translate(-33.384 -9.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_3944",
    "data-name": "Path 3944",
    d: "M6.109 75.1l1.6 1.072a.155.155 0 00.227-.194l-.808-1.751a.968.968 0 01.074-.942l1.072-1.6a.155.155 0 00-.194-.227l-1.751.807a.965.965 0 01-.942-.074l-1.6-1.072a.155.155 0 00-.227.194l.808 1.751a.967.967 0 01-.073.936l-1.072 1.6a.155.155 0 00.194.227l1.751-.807a.965.965 0 01.942.074",
    transform: "translate(2.127 -31.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_3945",
    "data-name": "Path 3945",
    d: "M59.881 19.513l1.6 1.072a.155.155 0 00.227-.194L60.9 18.64a.968.968 0 01.074-.942l1.072-1.6a.155.155 0 00-.194-.227l-1.751.807a.965.965 0 01-.942-.074l-1.6-1.072a.155.155 0 00-.227.194l.808 1.751a.967.967 0 01-.075.942l-1.072 1.6a.155.155 0 00.194.227l1.751-.807a.965.965 0 01.942.074",
    transform: "translate(-243.384 1.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "account-error_svg__Path_3946",
    "data-name": "Path 3946",
    d: "M59.881 19.513l1.6 1.072a.155.155 0 00.227-.194L60.9 18.64a.968.968 0 01.074-.942l1.072-1.6a.155.155 0 00-.194-.227l-1.751.807a.965.965 0 01-.942-.074l-1.6-1.072a.155.155 0 00-.227.194l.808 1.751a.967.967 0 01-.075.942l-1.072 1.6a.155.155 0 00.194.227l1.751-.807a.965.965 0 01.942.074",
    transform: "translate(-163.384 130.915)"
  })))));
}
export default __webpack_public_path__ + "static/account-error.8f827a2b.svg";
export { SvgAccountError as ReactComponent };